import { render, staticRenderFns } from "./otelyolcumnerede.vue?vue&type=template&id=dfd9d41c&scoped=true&"
import script from "./otelyolcumnerede.vue?vue&type=script&lang=js&"
export * from "./otelyolcumnerede.vue?vue&type=script&lang=js&"
import style0 from "./otelyolcumnerede.vue?vue&type=style&index=0&id=dfd9d41c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd9d41c",
  null
  
)

export default component.exports